import { render } from "./UserItem.vue?vue&type=template&id=6b908cae&ts=true"
import script from "./UserItem.ts?vue&type=script&lang=ts"
export * from "./UserItem.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__